import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import cache from '@/utils/cache'
import jssha256 from 'js-sha256'

const axiosInstance = axios.create({
    headers: {
        "access": "&OSpYVy#6g^Q7Fo#",
        "Access-Control-Allow-Origin": "*",
    },
    withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    timeout: 15000
});
axiosInstance.defaults.baseURL = '/'
// axiosInstance.defaults.baseURL = 'http://103.78.229.28:5001/'
// axiosInstance.defaults.baseURL = 'http://192.168.0.103:5000/'
Vue.prototype.$http = axiosInstance
const ajaxURL = {
    // 主页
    home: {
        url: '/api/article/home',
        method: "api.user.register"
    },
    article: {
        url: '/api/article/findBy',
        method: "api.user.register"
    },
    leavemessage: {
        url: '/api/leavemessage/saveNew',
        method: "api.user.register"
    },
}

export var request = async (type = 'POST', url = '', data = {}) => {
    let result
    type = type.toUpperCase()

    let token = cache.getSession('token');
    let timestamp = (new Date()).valueOf();
    let sign = jssha256.sha256(timestamp + "&OSpYVy#6g^Q7Fo#" + "nx24Tej@R4gWVCopJkjHWjBo@n58LdQ5")
    let headers = {
        "ts": timestamp,
        "sign": sign,
        "token": token
    }

    if (url == "captcha") {
        data.ts = timestamp;
        let signSms = jssha256.sha256(timestamp + data.phone + "nx24Tej@R4gWVCopJkjHWjBo@n58LdQ5")
        data.sign = signSms
    }
    url = ajaxURL[url].url

    if (type === 'GET') {
        await axiosInstance.get(url, {
            params: data,
            headers: headers
        }).then(res => {
            result = res.data
        })
    } else if (type === 'POST') {
        await axiosInstance.post(url, qs.stringify(data), {
            headers: headers
        }).then(res => {
            result = res.data
        })
    }
    return result
}
